import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";

export type DropdownFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useDropdownFieldController = (props: DropdownFieldProps) => {
  const { datasheetElement, onChange } = props;

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const handleFieldValueSave = React.useCallback((id: string | number) => {
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          value: id,
        },
      },
    });
  }, [onChange, datasheetElement]);

  const normalizeDropdownOptions = React.useMemo((): Array<{ label: string; value: string; }> => {
    // if (!datasheetElement.original.field.options?.length) {
    //   return [];
    // }

    // return datasheetElement.original.field.options.map((option) => ({
    //   value: option.actualValue,
    //   label: option.displayValue
    // }))

    return [];
  }, []);

  return {
    handleFieldValueSave,
    headingPosition,
    headingPlacedHorizontally,
    normalizeDropdownOptions,
    ...baseDatasheetElementController,
  };
};